import { Button, DatePicker, Form, Input, InputNumber, Select } from 'antd'
import { memo, useCallback, useEffect, useState } from 'react'
import { Player, PlayerFoot } from 'types/players'
import { Position } from 'types/positions'
import { getPositions } from 'services/positions'
import dayjs from 'dayjs'

type Props = {
    player: Player
    onSubmit: (player: Player) => void
    loading: boolean
}

export const PlayerForm = memo((props: Props) => {
    const { player, onSubmit, loading } = props
    const [positions, setPositions] = useState<Position[]>([])

    useEffect(() => {
        getPositions().then(data => {
            setPositions(data)
        })
    }, [])

    const onFinish = useCallback(
        (values: Player) => {
            if (values.birthday) {
                values.birthday = dayjs(values.birthday).format('YYYY-MM-DD')
            }

            onSubmit(values)
        },
        [onSubmit]
    )

    return (
        <Form
            name='basic'
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
            initialValues={{ remember: true }}
            onFinish={onFinish}
            autoComplete='off'
            disabled={loading}
        >
            <Form.Item
                initialValue={player.name}
                label='Name'
                name='name'
                rules={[{ required: true, message: 'Please input player name!' }]}
            >
                <Input />
            </Form.Item>

            <Form.Item
                initialValue={player.surname}
                label='Surname'
                name='surname'
                rules={[{ required: true, message: 'Please input player surname!' }]}
            >
                <Input />
            </Form.Item>

            <Form.Item
                initialValue={player.email}
                label='E-mail'
                name='email'
                rules={[{ type: 'email', message: 'E-mail is not correct!' }]}
            >
                <Input />
            </Form.Item>

            <Form.Item initialValue={player.phone} label='Phone' name='phone'>
                <Input />
            </Form.Item>

            <Form.Item initialValue={player.instagram ?? undefined} label='Instagram' name='instagram'>
                <Input placeholder='Full link' />
            </Form.Item>

            <Form.Item initialValue={player.telegram ?? undefined} label='Telegram' name='telegram'>
                <Input placeholder='Full link' />
            </Form.Item>

            <Form.Item initialValue={player.photo} label='Photo' name='photo'>
                <Input />
            </Form.Item>

            <Form.Item initialValue={player.birthday && dayjs(player.birthday)} label='Birthday' name='birthday'>
                <DatePicker format={'DD.MM.YYYY'} />
            </Form.Item>

            <Form.Item
                initialValue={player['id_position']}
                name='id_position'
                label='Position'
                rules={[{ required: true, message: 'Please select position!' }]}
            >
                <Select>
                    {positions.map(it => (
                        <Select.Option key={it.id} value={it.id}>
                            {it.name}
                        </Select.Option>
                    ))}
                </Select>
            </Form.Item>

            <Form.Item initialValue={player.weight ?? undefined} label='Weight' name='weight'>
                <InputNumber min={1} placeholder='kg' />
            </Form.Item>

            <Form.Item initialValue={player.height ?? undefined} label='Height' name='height'>
                <InputNumber min={1} placeholder='cm' />
            </Form.Item>

            <Form.Item initialValue={player.working_foot ?? undefined} label='Working foot' name='working_foot'>
                <Select allowClear placeholder='Select foot'>
                    <Select.Option value={'left' satisfies PlayerFoot}>Левая</Select.Option>
                    <Select.Option value={'right' satisfies PlayerFoot}>Правая</Select.Option>
                    <Select.Option value={'both' satisfies PlayerFoot}>Обе</Select.Option>
                </Select>
            </Form.Item>

            <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
                <Button type='primary' htmlType='submit'>
                    Submit
                </Button>
                <Button htmlType={'reset'}>Reset</Button>
            </Form.Item>
        </Form>
    )
})
